import ModalComponent from "../../Components/ModalComponent";
import { Button, Col, Form, Row, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { InputOTP } from "antd-input-otp";
import { showNotitfication } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import {
  toEditProfileOtp,
  toGetProfil,
  toRegenerateEditOtp,
} from "../../apis/actions/auth.actions";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

interface EditProfileOtpProps {
  onClose: () => void;
  open?: boolean;
  data?: any;
  OtpTimeLeft?: number;
  onSuccess?: () => void; // Add this new prop
}

const EditProfileOtp = ({
  open,
  onClose,
  data,
  OtpTimeLeft,
  onSuccess, // Add this
}: EditProfileOtpProps) => {
  const [form] = Form.useForm();

  const otpValue = Form.useWatch("otp", form);
  const [loadingReg, setLoadingReg] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const { profil } = useSelector((state: RootState) => state?.login);
  const [otpError, setOtpError] = useState<string | null>(null); // <-- NEW STATE

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { t, i18n } = useTranslation();
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    dispatch(toGetProfil(i18n.language));
  }, [dispatch]);
  const isOtpInvalid =
    !otpValue ||
    otpValue.length !== 4 ||
    otpValue.includes(undefined) ||
    otpValue.includes("");

  useEffect(() => {
    if (OtpTimeLeft) {
      setTimeLeft(OtpTimeLeft);
    } else {
      setTimeLeft(0);
      if (timerRef.current) clearInterval(timerRef.current);
    }
  }, [OtpTimeLeft, open]);

  useEffect(() => {
    if (timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [timeLeft]);
  const handleVerifyOtp = async () => {
    const otp = form.getFieldValue("otp");
    form.validateFields();
    setLoading(true);
    if (
      !otp ||
      otp.length !== 4 ||
      !otp ||
      otp.includes(undefined) ||
      otp.includes("")
    )
      return form.setFields([
        {
          name: "otp",
          errors: [t("otp.warning")],
        },
      ]);
    else {
      {
        const success = (await dispatch(
          toEditProfileOtp({
            otp: `${otp[0]}${otp[1]}${otp[2]}${otp[3]}`,
            ...data,
            login: profil?.data?.phone,
          })
        )) as any;
        const verifyOtp = success?.payload?.data?.result;
        if (verifyOtp?.code === 200) {
          setOtpError(null);
          showNotitfication(
            i18n.language === "ar"
              ? "تم تعديل الحساب بنجاح!"
              : "Account updated successfully!",
            "success"
          );
          dispatch(toGetProfil(i18n.language));
          onSuccess?.();
        } else if (verifyOtp?.code === 401) {
          setOtpError(
            i18n.language === "ar"
              ? "لقد تجاوزت عدد المحاولات المسموح بها. يرجى طلب رمز تحقق جديد."
              : "You have exceeded the allowed number of attempts. Please request a new verification code."
          );
          setTimeLeft(0);
        } else {
          const errorMessage =
            verifyOtp?.code === 400
              ? i18n.language === "ar"
                ? "رمز التحقق غير صالح"
                : "Invalid OTP "
              : verifyOtp?.message;

          showNotitfication(errorMessage, "error");
        }
      }
    }
    setLoading(false);
  };
  const RegenrateOtp = async () => {
    setOtpError(null);
    setLoadingReg(true);

    const payload: { mobile?: string; email?: string } = {};
    if (data?.phone) payload.mobile = data.phone;
    if (data?.email) payload.email = data.email;

    const success = (await dispatch(
      toRegenerateEditOtp({
        data: payload,
        lang: i18n.language,
      })
    )) as any;

    const RegenerateOtp = success?.payload?.data?.result;

    if (RegenerateOtp?.code === 200) {
      const seconds = RegenerateOtp?.time_left || 0;
      setTimeLeft(seconds);
    } else {
      form.resetFields();
      const seconds = RegenerateOtp?.time_left || 0;
      setTimeLeft(seconds);
      showNotitfication(RegenerateOtp?.message, "error");
    }

    setLoadingReg(false);
  };
  const handleClose = () => {
    setOtpError(null);
    form.resetFields();
    setTimeLeft(0);
    onClose?.();
  };
  return (
    <>
      <ModalComponent
        width={450}
        title=""
        open={open}
        onClose={handleClose}
        closeOnOutsideClick={true}
        modalStyle={{ top: 90 }}
      >
        <div
          className="otp-modal-content "
          style={{
            direction: i18n.language === "ar" ? "rtl" : "ltr",
            textAlign: i18n.language === "ar" ? "right" : "left",
          }}
        >
          <div
            className="otp-modal-header "
            style={{ textAlign: "center", marginBottom: "1rem" }}
          >
            <h6
              style={{ fontWeight: 600, marginTop: "2rem" }}
              className="ac--font-expo"
            >
              {i18n.language === "ar"
                ? "قم بتأكيد رقم الجوال"
                : "Verify your mobile number"}
            </h6>{" "}
            <p className="ac--font-expo">
              {i18n.language === "ar"
                ? `أدخل رمز التحقق المكون من 4 أرقام والمرسل إلى`
                : "Enter the 4-digit OTP sent to"}
              <br />
              <strong className="ac--font-expo">
                {data?.phone || data?.email}
              </strong>
            </p>
          </div>

          <Form form={form} layout="vertical" onFinish={handleVerifyOtp}>
            <Form.Item
              name="otp"
              rules={[{ required: true, message: t("otp.warning") }]}
              style={{ textAlign: "center", direction: "ltr" }}
            >
              <InputOTP autoFocus inputMode="tel" length={4} />
            </Form.Item>
            <div
              style={{
                textAlign: "center",
                marginTop: "2rem",
              }}
            >
              {timeLeft > 0 ? (
                <span className="ac--font-expo" style={{ color: "#999" }}>
                  {i18n.language === "ar"
                    ? `ستنتهي صلاحية رمز التحقق خلال ${timeLeft} ثانية`
                    : `OTP will expire in ${timeLeft} seconds`}
                </span>
              ) : !loadingReg ? (
                <>
                  {otpError ? (
                    // 🔹 Show red error message when attempts are exceeded
                    <>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "red",
                          //fontWeight: "bold",
                          display: "block",
                          marginBottom: "6px",
                        }}
                      >
                        {otpError}
                      </span>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "#5C9DFF",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={RegenrateOtp}
                      >
                        {i18n.language === "ar"
                          ? "إعادة إرسال رمز التحقق"
                          : "Resend OTP"}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        className="ac--font-expo"
                        style={{ display: "block" }}
                      >
                        {i18n.language === "ar"
                          ? "لم تتلقى رمز التحقق؟"
                          : "Didn't get the OTP?"}
                      </span>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "#5C9DFF",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={RegenrateOtp}
                      >
                        {i18n.language === "ar"
                          ? "إعادة إرسال رمز التحقق"
                          : "Resend OTP"}
                      </span>
                    </>
                  )}
                </>
              ) : (
                <Spin size="small" className="me-2" />
              )}
            </div>
            <div
              style={{
                background: "#FFF9E5",
                padding: "5px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                marginTop: 20,
                fontSize: 12,
              }}
            >
              <img
                src="/assets/imgs/template/icons/light.svg"
                alt="tip"
                style={{ width: 16, height: 16 }}
              />
              <span className="ac--font-expo">
                {i18n.language === "ar"
                  ? "يحمي رمز التحقق حسابك من الوصول غير المصرح به"
                  : "OTP verification protects your account from unauthorized access."}
              </span>
            </div>
            <Row justify={"center"} style={{ marginTop: "1rem" }}>
              <Col span={22}>
                <Button
                  htmlType="submit"
                  style={{ width: "100%" }}
                  type="primary"
                  className=" ac--btn-primary-jflatbold mt-30"
                  disabled={
                    isOtpInvalid ||
                    loading ||
                    otpError !== null ||
                    timeLeft == 0
                  }
                  loading={loading}
                >
                  {i18n.language === "ar" ? "تأكيد" : "Verify"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </ModalComponent>
    </>
  );
};

export default EditProfileOtp;
